import { useCallback } from 'react'

import { useApiOrigin } from '@/utils/env'
import { useAuthorizationHeader } from '@/utils/auth'

export function useShareSpotConfirm() {
  const apiBase = useApiOrigin()
  const authorizationHeader = useAuthorizationHeader()

  const SHARESPOT_PAYMENT_UNPAID_SYNC_URL = '/v4/share-spot/payment/unpaid/sync'

  return useCallback(
    async (userPublicId: string) => {
      try {
        const url = new URL(
          `${SHARESPOT_PAYMENT_UNPAID_SYNC_URL}/${encodeURIComponent(
            userPublicId
          )}`,
          apiBase
        ).toString()
        const res = await window.fetch(url, {
          method: 'POST',
          headers: {
            ...(await authorizationHeader()),
            'Content-Type': 'application/json',
          },
        })

        if (res.ok) return

        const errorText = await res.text().catch(() => null)
        const error = Object.assign(
          new Error('ShareSpot confirm request failed'),
          { status: res.status, body: errorText }
        )
        throw error
      } catch (error) {
        console.error('ShareSpot confirm failed:', {
          error,
          url: `${SHARESPOT_PAYMENT_UNPAID_SYNC_URL}/${userPublicId}`,
          timestamp: new Date().toISOString(),
        })
      }
    },
    [authorizationHeader, apiBase]
  )
}
